import { Type } from "@sinclair/typebox";
import {
  probabilisticBlockingRules,
  probabilisticCompositeFeatureNames,
} from "./matching-rules";

const customProbabilisticIdentifierNamePattern = "^[a-z][a-z0-9_]*$";
export const customProbabilisticIdentifierFeatureSuffix = "_match";
const probabilisticFeatureNameMaxLength = 255;
const customProbabilisticIdentifierNameMaxLength =
  probabilisticFeatureNameMaxLength -
  customProbabilisticIdentifierFeatureSuffix.length;

export const CustomProbabilisticIdentifierNameSchema = Type.String({
  minLength: 1,
  maxLength: customProbabilisticIdentifierNameMaxLength,
  pattern: customProbabilisticIdentifierNamePattern,
});

const probabilisticInputMetadataIdentifiers: ReadonlyArray<string> = [
  "id",
  "source",
  "primary_key",
  "ht_id",
  "is_identifier_backfill",
];

const snowflakeReservedOrLimitedKeywords: ReadonlyArray<string> = [
  "account",
  "all",
  "alter",
  "and",
  "any",
  "as",
  "between",
  "by",
  "case",
  "cast",
  "check",
  "column",
  "connect",
  "connection",
  "constraint",
  "create",
  "cross",
  "current",
  "current_date",
  "current_time",
  "current_timestamp",
  "current_user",
  "database",
  "delete",
  "distinct",
  "drop",
  "else",
  "exists",
  "false",
  "following",
  "for",
  "from",
  "full",
  "grant",
  "group",
  "gscluster",
  "having",
  "ilike",
  "in",
  "increment",
  "inner",
  "insert",
  "intersect",
  "into",
  "is",
  "issue",
  "join",
  "lateral",
  "left",
  "like",
  "localtime",
  "localtimestamp",
  "minus",
  "natural",
  "not",
  "null",
  "of",
  "on",
  "or",
  "order",
  "organization",
  "qualify",
  "regexp",
  "revoke",
  "right",
  "rlike",
  "row",
  "rows",
  "sample",
  "schema",
  "select",
  "set",
  "some",
  "start",
  "table",
  "tablesample",
  "then",
  "to",
  "trigger",
  "true",
  "try_cast",
  "union",
  "unique",
  "update",
  "using",
  "values",
  "view",
  "when",
  "whenever",
  "where",
  "window",
  "with",
];

export const reservedCustomProbabilisticIdentifiers = new Set([
  ...probabilisticInputMetadataIdentifiers,
  ...snowflakeReservedOrLimitedKeywords,
  ...probabilisticBlockingRules.map((rule) => rule.join("_")),
  ...probabilisticCompositeFeatureNames.map((name) =>
    name.replace(/_similarity$/, ""),
  ),
]);
